import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, InputField } from '../form';
import { FormGroup, Button } from 'reactstrap';


import { registrationSuccess, registrationUnload, redeemCouponSuccess } from '../../actions';

import { User } from '../../api';
import { Coupon } from '../../api';

import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { currentUserSelector } from '../../reducers/selectors'

const mapStateToProps = state => ({ currentUser: currentUserSelector(state) });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({registrationSuccess: registrationSuccess, onUnload: registrationUnload, redeemCouponSuccess: redeemCouponSuccess}, dispatch);
};



class RedeemForm extends Component {
  
  constructor (props){
    super(props);
    
    const params = queryString.parse(props.location.search);
    const { email, ref, coupon_code } = params;
    
    this.state = {
      initialValues: {email, ref, coupon_code}
    }
  }
  
  render () {
    const { currentUser, registrationSuccess, redeemCouponSuccess } = this.props
    
    const onSubmit = currentUser ? Coupon.redeem : User.create
    const onSuccess = currentUser ? redeemCouponSuccess : registrationSuccess
    
    return (
      <div className="panel">
        <div className="panel-body">
          <h3 className="text-center">Reedeem coupon</h3>
          
          <Form
            onSubmit={onSubmit}
            onSuccess={onSuccess}
            onFail={console.error}
            initialValues={this.state.initialValues}
            validate={values => {
              const errors = {};
              return errors;
            }}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
            
              <form onSubmit={handleSubmit} noValidate={true}>
                
                <FormGroup>
                  <InputField meta={{submitting}} name="coupon_code" type="text" placeholder="Coupon Code" />
                </FormGroup>
                
                { !currentUser && <React.Fragment>
                  <FormGroup>
                    <InputField meta={{submitting}} name="name" type="text" placeholder="Your name" />
                  </FormGroup>
                
                  <FormGroup>
                    <InputField meta={{submitting}} name="email" type="email" placeholder="Email" />
                  </FormGroup>
                
                  <FormGroup>
                    <InputField meta={{submitting}} name="password" type="password" placeholder="Password" />
                  </FormGroup>
                </React.Fragment> }
                
                <FormGroup>
                  <Button
                    className="upcase"
                    color="primary"
                    type="submit"
                    block
                    disabled={submitting}>
                    { !currentUser ? 'Sign up & Redeem' : 'Redeem' }
                  </Button>
                </FormGroup>
                
                { !currentUser && <div className="small text-center">
                  By creating an account you agree with our <a href="https://shorby.com/terms" target="_blank" without rel="noopener noreferrer">terms</a> and <a href="https://shorby.com/terms" target="_blank" without rel="noopener noreferrer">privacy policy</a>
                </div> }
                { false && <pre>{JSON.stringify(values, 0, 2)}</pre> }
              </form>
            )}
          />
        </div>
        { !currentUser && <div className="panel-footer text-center">
          <Link to="/login">Already have an account? Sign in &rarr;</Link>
        </div> }
      </div>
    )
  };
}


export default connect(mapStateToProps, matchDispatchToProps)(RedeemForm);


// WEBPACK FOOTER //
// ./src/components/auth/Redeem.js